import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { signal } from '@angular/core';
import { environment } from '../../../environments/environment';

export const loadingState = signal(0);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  // Only track loading for requests to our own API (avoids spinner on autocomplete calls, etc.)
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const currentCount = loadingState();
  loadingState.set(currentCount + 1);

  return next(req).pipe(
    finalize(() => {
      const count = loadingState();
      loadingState.set(Math.max(0, count - 1));
    }),
  );
};

// TODO: Add computed signal for loading status in app. -l
/**
 * Computed signal to determine if loading should be shown.
 * Use this in templates or components to conditionally show loading indicators.
 *
 * Example:
 * isLoading = computed(() => loadingState() > 0);
 */
